export const FEEDBACK_TABLE_DEFAULT_FILTERS = [
	'type',
	'organisation_member_type',
	'category',
	'severity',
	'stage',
]
